import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../baseQuery";

// Custom base query for axios that properly handles interceptors

export const wishlistApi = createApi({
  reducerPath: "wishlistApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Wishlist"],
  endpoints: (builder) => ({
    getBrandWishlist: builder.query({
      query: ({
        pagination = { page: 1, rows_per_page: 10 },
        admin_brand_id,
        brand_id,
        wishlink_username,
      }) => ({
        url: `brand/wishlists`,
        method: "POST",
        body: {
          pagination,
          ...(admin_brand_id && { admin_brand_id }),
          ...(brand_id && { brand_id }),
          ...(wishlink_username && { wishlink_username }),
        },
      }),
      providesTags: ["Wishlist"],
      keepUnusedDataFor: 0,
    }),
    getWishlistDetails: builder.query({
      query: ({ wishlistId, pagination = { page: 1, rows_per_page: 10 } }) => ({
        url: `wishlists/${wishlistId}`,
        method: "POST",
        body: {
          pagination,
        },
      }),
      providesTags: ["Wishlist"],
      keepUnusedDataFor: 0,
    }),
    createWishlist: builder.mutation({
      query: (body) => ({
        url: `wishlists`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Wishlist"],
    }),
    deleteWishlist: builder.mutation({
      query: (wishlistId) => ({
        url: `wishlists/${wishlistId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Wishlist"],
    }),
    updateWishlist: builder.mutation({
      query: ({ wishlistId, body }) => ({
        url: `wishlists/${wishlistId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Wishlist"],
    }),
    addCreatorToWishlist: builder.mutation({
      query: ({ creatorId, body }) => ({
        url: `/creators/${creatorId}/wishlists`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Wishlist"],
    }),
    deleteCreatorFromWishlist: builder.mutation({
      query: ({ creatorId, wishlistId }) => ({
        url: `/creators/${creatorId}/wishlist/${wishlistId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Wishlist"],
    }),
    exportWishlist: builder.mutation({
      query: ({ wishlistId }) => ({
        url: `/wishlists/${wishlistId}/export`,
        method: "POST",
        body: {
          format: "csv",
        },
      }),
    }),
  }),
});

export const {
  useLazyGetBrandWishlistQuery,
  useLazyGetWishlistDetailsQuery,
  useCreateWishlistMutation,
  useDeleteWishlistMutation,
  useUpdateWishlistMutation,
  useAddCreatorToWishlistMutation,
  useDeleteCreatorFromWishlistMutation,
  useExportWishlistMutation,
} = wishlistApi;
